@if (paymentData?.paymentMethod === 'sepa') {
  <div>
    <h5 class="re-mb-30">{{ 'banking.sepa.sepaMandate' | translate }}</h5>
    <div class="re-summary-row">
      <div>{{ 'banking.iban' | translate }}</div>
      <div>{{ paymentData?.bankData?.iban | maskIBAN }}</div>
    </div>
    <div class="re-summary-row re-mb-0">
      <div>{{ 'banking.bankname' | translate }}</div>
      <div>{{ paymentData?.bankData?.bankname }}</div>
    </div>
  </div>
} @else {
  <h5 class="re-mb-30">{{ 'banking.manual' | translate }}</h5>
  @if (!noFutureContract) {
    <div [innerHTML]="'payment.bankTransfer.description' | translate"></div>
  }
  @if (noFutureContract) {
    <div>{{ 'summary.payment.lastPaymentInfo' | translate }}</div>
  }
}
@if (promoCode) {
  <div class="re-summary-row re-mt-15">
    <div>{{ 'payment.promoCode.label' | translate }}</div>
    <div data-qa="summary-promo-code">{{ promoCode }}</div>
  </div>
}
